import { Constantes } from "./../../utils/Constantes";
import { SPParse } from "../../utils/SPParse";

export class EProyecto {
    ID: string;
    Title: string;
    TitleEN: string;
    Longitud: any;
    Habilitado: boolean;
    Codigo: string;
    CodigoInternoACC: string;

    constructor() {
        this.ID = "0";
        this.Title = "";
        this.TitleEN = "";
        this.Longitud = null;
        this.Habilitado = false;
        this.Codigo = "";
        this.CodigoInternoACC = "";
    }

    public static parseJsonBack(element: any): EProyecto {

        const objeto = new EProyecto();
        objeto.ID = SPParse.getNumber(element["id"]).toString();
        objeto.Title = SPParse.getString(element["title"]);
        objeto.TitleEN = SPParse.getString(element["titleEN"]);
        objeto.Longitud = element["longitud"];
        objeto.Habilitado = SPParse.getBool(element["habilitado"]);
        objeto.Codigo = SPParse.getString(element["codigo"]);
        objeto.CodigoInternoACC = SPParse.getString(element["codigoInternoACC"]);
        return objeto;
    }
}
